module.exports = __webpack_public_path__ + "static/media/better_way_right.72a731c1.png";